import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { CustomerDetailsService } from 'src/app/angularJS/services/customer-detail/customer-detail.service';
import { PhotoService } from 'src/app/angularJS/services/photo/photo.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';

export class CustomerEditController {
  public static $inject = ['$rootScope', '$state', '$translate', '$window', 'customerService', 'userService', 'customer', 'customerDetailService', 'photoService', 'UserMessages', 'customerConstants', 'customerImage'];
  public photo: any;
  public titles: string;
  public customerStatus: string;
  public addressTypes: string;
  public contactTypes: string;
  public customer: InterACT.Interfaces.Customers.Customer;
  public scheme: InterACT.Interfaces.Schemes.Scheme;
  public currentLocale: string;
  public regexList: any;
  public currentDate: Date;
  public showPhotoTool: boolean;
  public placeholder: string;
  public enhancedDetails: any;

  constructor(
    private $rootScope,
    private $state: ng.ui.IStateService,
    private $translate: ng.translate.ITranslateService,
    private $window: ng.IWindowService,
    private customerService: CustomerService,
    private userService: UserService,
    customer: InterACT.Interfaces.Customers.Customer,
    private customerDetailService: CustomerDetailsService,
    private photoService: PhotoService,
    private UserMessages: UserMessagesService,
    private customerConstants,
    private customerImage: string) {
    this.customerStatus = customerConstants.CUSTOMER_STATUS;
    this.titles = customerConstants.SALUTATIONS;
    this.addressTypes = customerConstants.ADDRESS_TYPES;
    this.contactTypes = customerConstants.CONTACT_TYPES;
    this.addAddress = customerDetailService.addAddress;
    this.addContactDetail = customerDetailService.addContactDetail;
    this.deleteAddress = customerDetailService.deleteAddress;
    this.deleteContactDetail = customerDetailService.deleteContactDetail;
    this.customer = angular.copy(customer);
    this.showPhotoTool = false;
    this.photo;
    this.scheme = this.userService.selectedScheme;
    this.placeholder = customer.scheme.abbreviation;
    this.currentLocale = $translate.use();
    this.regexList = customerConstants.REGEX_LIST;
    this.customer.dob = <any>new Date(moment(customer.dob).format('YYYY-MM-DD'));
    this.currentDate = new Date();
    this.activate();
  }

  public addAddress = (customer: InterACT.Interfaces.Customers.Customer) => {
    this.customerDetailService.addAddress(customer);
  }

  public addContactDetail = (customer: InterACT.Interfaces.Customers.Customer) => {
    this.customerDetailService.addContactDetail(customer);
  }

  public deleteAddress = (customer: InterACT.Interfaces.Customers.Customer, address: InterACT.Interfaces.Customers.CustomerAddress) => {
    this.customerDetailService.deleteAddress(customer, address);
  }

  public deleteContactDetail = (customer: InterACT.Interfaces.Customers.Customer, contactDetail: InterACT.Interfaces.Customers.CustomerContactDetail) => {
    this.customerDetailService.deleteContactDetail(customer, contactDetail);
  }

  public goToCustomer = () => {
    this.$state.go('customer.details', {
      customerId: this.customer.id
    });
  }

  public editCustomer = (customFields) => {
    this.$rootScope.showSpinner = true;
    if (angular.isDefined(customFields)) {
      this.customerDetailService.addSchemaFields(this.customer, customFields);
    } else {
      this.customerDetailService.clearSchemaFields(this.customer);
    }

    this.customer.contactDetails = _.filter(this.customer.contactDetails, (item) => {
      return item.detail !== '';
    });
    if (this.customer.contactDetails.length < 1) {
      delete this.customer.contactDetails;
    }
    if (this.customer.addresses.length < 1) {
      delete this.customer.addresses;
    }

    if (this.scheme) {
      this.customer.scheme = {
        abbreviation: this.scheme.reference,
        link: '/schemes/' + this.scheme.id
      };
    }

    if (this.customer.title) {
      this.customer.title.toUpperCase();
    }

    let copiedCustomer = JSON.parse(JSON.stringify(this.customer));

    if( copiedCustomer.contactDetails ) {
      copiedCustomer.contactDetails.forEach(contact => {
        delete contact.icon;
      })
    }

    this.customerService.update(copiedCustomer.id, copiedCustomer).then(() => {
      this.UserMessages.showToast('TOAST_MESSAGE.CUSTOMER.EDITED');
      if (this.photo) {
        this.createPhoto(this.customer.id);
      } else {
        this.$rootScope.showSpinner = false;
        this.goToCustomer();
      }
    });
  }

  public showAddPhotoTool = () => {
    this.showPhotoTool = true;
  }

  public setPhoto = (data, name: string) => {
    this.photo = { data: data, name: name };
  }

  public createPhoto = (customerId: string) => {
    this.$rootScope.showSpinner = true;
    this.photoService.create(customerId, this.photo.data, this.photo.name).then(() => {
      this.$rootScope.showSpinner = false;
      this.UserMessages.showToast('PHOTOS.SUCCESS');
      this.goToCustomer();
    });
  }

  public getCustomerSchemaId = () => {
    if (this.customer && this.customer.fields) {
      return this.customer.fields.schema.link.split('/customer-schemas/').pop();
    }
  }

  private activate() {
    if (this.customer.title) {
      this.customer.title = this.customer.title.toUpperCase();
    }
    this.enhancedDetails = this.customerDetailService.getEnhancedCustomerData(this.customer);
    // Need to find matching scheme object to schemeLink in customer to preset the scheme select
    this.scheme = _.find(this.userService.schemes, (scheme: any) => {
      return scheme.reference === this.customer.scheme.abbreviation;
    });
  }
}
